import { runtimeVersion, updateId } from 'expo-updates';
import { Platform } from 'react-native';

import { getCurrentCommitHash } from 'utils/environment';

import { withHeaders } from './with-headers';

const getApolloVersion = (): string => {
  const rv = runtimeVersion ?? 'no-rv';
  const uid = (updateId ?? 'no-uid').slice(-12); // get last 12 of UUID
  const hash = getCurrentCommitHash().substring(0, 7); // get first 7
  return `${rv}-${uid}-${hash}`;
};

const VERSION = getApolloVersion();
const NAME = `wl-rn-${Platform.OS}`; // TODO: frontend forks should replace "wl" with their own name.

export const withClientInfo = withHeaders(() => {
  return {
    'apollographql-client-name': NAME,
    'apollographql-client-version': VERSION,
  };
});
